import { Component, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { BaseAppEditComponent } from '@app/cp/shared/base-components/base-app-edit.component';
import { SaveMode } from '../../shared/enums/SaveMode';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { DispatchBus } from '../../shared/models/DispatchBus';
import { CommonValues } from '../../shared/static/CommonValues';
import { CommonFunctions } from '../../shared/static/common-functions';

@Component({
    selector: 'callback-rfb-check',
    templateUrl: './callback-rfb-check.component.html',
    styleUrls: ['./callback-rfb-check.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CallbackRFBCheckComponent extends BaseAppEditComponent<DispatchBus, DispatchesService>  {

    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: DispatchesService) {
        super(globals, qry_rd);
        this.appCode = "CallbackRFBCheck";
        this.svc_data = svc_data;
        this.saveMode = SaveMode.all;
        this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.validAccountClasses = []; //
        this.validAccountClasses.push(CommonValues.AccountClass_ReferService);
        this.validAccountClasses.push(CommonValues.AccountClass_ReferService_PM);
        this.validAccountClasses.push(CommonValues.AccountClass_HVACService);
        this.validAccountClasses.push(CommonValues.AccountClass_HVACService_PM);
        this.validAccountClasses.push(CommonValues.AccountClass_Contract);
        this.validAccountClasses.push(CommonValues.AccountClass_Contract_PM);
    }
    accountClassId: any;
    validAccountClasses: any[];
    @Input() data: DispatchBus;

    get hasData(): boolean {
        return CommonFunctions.hasValue(this.data);
    }
    protected _active: boolean = false;
    @Input() set active(value: boolean) {
        this.beforeActiveSet(value);
        this._active = value;
    }

    get active(): boolean {
        return this._active;
    }
    beforeActiveSet(value: boolean) {
    //    if (value) {
    //        this.selectedData = this.data;
    //        this.setForm();
    //        this.readOnly = false;
    //    }
    }

    dispatchType: string = "";
    isCorrectType: boolean = false;
    onClick(dType: string) {
        this.dispatchType = dType;
        if (dType === "W") {
            this.accountClassId = CommonValues.AccountClass_WarrantyService;
        }
        else {
            this.accountClassId = this.originalAccountClassId;
            let acctClassId: any = this.validAccountClasses.find(s => s == this.accountClassId);
            this.isCorrectType = CommonFunctions.hasGuidValue(acctClassId);
        }
    }
    cancel() {
        this.close(null, false);
    }
    public getChangeNote() : string {
        let personName = this.referenceData.getPerson(this.globals.personId);
        let acctClassDesc = this.referenceData.getAccountClassDesc(this.accountClassId);
        let note = ""
        if (this.dispatchType == "W") {
            note = "Because this is a CallBack the user (" + personName + ") chose Warranty Service Class: " + acctClassDesc +".";
        }
        else {
            note = "Because this is not a CallBack the user (" + personName + ") chose "
            if (this.accountClassId == this.originalAccountClassId) {
                note = note + "to use current "
            }
        //    else {
        //        note = note + ""
        //    }
            note = note + "Billable Service Class: " + acctClassDesc + ".";
        }

        return note;
    }
    showStatus: boolean = false;
    changeNote: string = "";
    saveAll() {
        this.changeNote = this.getChangeNote();
        this.close({
            dispatchType: this.dispatchType, accountClassId: this.accountClassId, isCorrectType: this.isCorrectType, changeNote: this.changeNote }, false);
    }
    get canSave(): boolean {
        let okToSave: boolean = this.dispatchType == 'B' || this.dispatchType == 'W';

        return okToSave;
    }
    classChanged(e: any) {

    }
    originalAccountClassId: any = null;
    setup(accountClassId: any) {
        this.dispatchType = "";
        this.changeNote = "";
        this.accountClassId = accountClassId;
        this.originalAccountClassId = this.accountClassId;
    }
}

